module.exports = __webpack_public_path__ + "img/vessel_new_century.8493b342.jpg";